import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }

  private emitViewChange = new Subject<string>();
  changeViewEmitted$ = this.emitViewChange.asObservable();
  viewVisible(view: string) { this.emitViewChange.next(view)}
}
